// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-card {
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-left: 4px solid #0ea5e9;
  border-radius: 8px;
  background: #f8fafc;
  max-width: 520px;
}

.confirmation-card--prod {
  border-left-color: #dc2626;
  background: #fef2f2;
}

.confirmation-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.confirmation-card__icon {
  font-size: 14px;
}

.confirmation-card__title {
  font-weight: 600;
  font-size: 13px;
  color: #0f172a;
}

.confirmation-card__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
}

.confirmation-card__action {
  font-weight: 600;
  font-size: 13px;
  color: #0f172a;
  margin-bottom: 2px;
}

.confirmation-card__param {
  display: flex;
  gap: 8px;
  font-size: 12px;
  color: #334155;
}

.confirmation-card__param-key {
  min-width: 120px;
  color: #64748b;
}

.confirmation-card__param-val {
  font-family: 'SFMono-Regular', Consolas, monospace;
  word-break: break-all;
}

.confirmation-card__prod-warning {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #dc2626;
}

.confirmation-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.confirmation-card__timer {
  font-size: 12px;
  color: #64748b;
}

.confirmation-card__buttons {
  display: flex;
  gap: 8px;
}

.confirmation-card__status {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

.confirmation-card__status--expired {
  color: #b45309;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmationCard/ConfirmationCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".confirmation-card {\n  margin-top: 10px;\n  padding: 12px 14px;\n  border: 1px solid #cbd5e1;\n  border-left: 4px solid #0ea5e9;\n  border-radius: 8px;\n  background: #f8fafc;\n  max-width: 520px;\n}\n\n.confirmation-card--prod {\n  border-left-color: #dc2626;\n  background: #fef2f2;\n}\n\n.confirmation-card__header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.confirmation-card__icon {\n  font-size: 14px;\n}\n\n.confirmation-card__title {\n  font-weight: 600;\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.confirmation-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 10px;\n}\n\n.confirmation-card__action {\n  font-weight: 600;\n  font-size: 13px;\n  color: #0f172a;\n  margin-bottom: 2px;\n}\n\n.confirmation-card__param {\n  display: flex;\n  gap: 8px;\n  font-size: 12px;\n  color: #334155;\n}\n\n.confirmation-card__param-key {\n  min-width: 120px;\n  color: #64748b;\n}\n\n.confirmation-card__param-val {\n  font-family: 'SFMono-Regular', Consolas, monospace;\n  word-break: break-all;\n}\n\n.confirmation-card__prod-warning {\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #dc2626;\n}\n\n.confirmation-card__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.confirmation-card__timer {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.confirmation-card__buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.confirmation-card__status {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.confirmation-card__status--expired {\n  color: #b45309;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
